module.exports = __webpack_public_path__ + "static/media/parts_20.ca21c1bd.svg";